/**
 * @name square-dashed-x
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjFoMSIgLz4KICA8cGF0aCBkPSJNMTQgM2gxIiAvPgogIDxwYXRoIGQ9Ik0xOSAzYTIgMiAwIDAxMiAyIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0yMSAxOWEyIDIgMCAwMS0yIDIiIC8+CiAgPHBhdGggZD0iTTIxIDl2MSIgLz4KICA8cGF0aCBkPSJNMyAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0zIDl2MSIgLz4KICA8cGF0aCBkPSJNNSAyMWEyIDIgMCAwMS0yLTIiIC8+CiAgPHBhdGggZD0iTTUgM2EyIDIgMCAwMC0yIDIiIC8+CiAgPHBhdGggZD0ibTkgMTUgNi02IiAvPgogIDxwYXRoIGQ9Ik05IDIxaDEiIC8+CiAgPHBhdGggZD0iTTkgM2gxIiAvPgogIDxwYXRoIGQ9Im05IDkgNiA2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/square-dashed-x
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const SquareDashedX: string = `
<svg
  class="lucide lucide-square-dashed-x"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M14 21h1" />
  <path d="M14 3h1" />
  <path d="M19 3a2 2 0 012 2" />
  <path d="M21 14v1" />
  <path d="M21 19a2 2 0 01-2 2" />
  <path d="M21 9v1" />
  <path d="M3 14v1" />
  <path d="M3 9v1" />
  <path d="M5 21a2 2 0 01-2-2" />
  <path d="M5 3a2 2 0 00-2 2" />
  <path d="m9 15 6-6" />
  <path d="M9 21h1" />
  <path d="M9 3h1" />
  <path d="m9 9 6 6" />
</svg>
`;

export default SquareDashedX;
